module.exports = __webpack_public_path__ + "static/media/Walchand_logo.5d457c69.png";